module.exports = __webpack_public_path__ + "img/success.b53d131e.svg";